import React, { useEffect } from "react";

import Table from "../../../Components/Table";
import { useAppSelector, useAppDispatch } from "../../../Store/Hooks";
import {
  fetchOrganizationLevels,
  fetchRelationshipLevels,
} from "../../../Store/Reducers/AdminSlice";

const levelCodeBadge = (value: string, tone: "al" | "rl") => (
  <span
    className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap ${
      tone === "al" ? "bg-blue-100 text-blue-800" : "bg-teal-100 text-teal-800"
    }`}
  >
    {value}
  </span>
);

const VendorLevelContainer = () => {
  const dispatch = useAppDispatch();
  const {
    organizationLevels,
    relationshipLevels,
    loading: levelsLoading,
    relationshipLevelsLoading,
  } = useAppSelector((state: any) => state.admin);

  useEffect(() => {
    dispatch(fetchOrganizationLevels());
    dispatch(fetchRelationshipLevels());
  }, [dispatch]);

  const alColumns = [
    {
      key: "level_code",
      title: "LEVEL CODE",
      render: (value: string) => levelCodeBadge(value, "al"),
      width: "200px",
    },
    {
      key: "name",
      title: "NAME",
      render: (value: string) => (
        <span className="font-semibold text-gray-900">{value}</span>
      ),
      width: "200px",
    },
    {
      key: "description",
      title: "DESCRIPTION",
      render: (value: string) => (
        <span className="text-gray-700 leading-relaxed">{value || "-"}</span>
      ),
    },
    {
      key: "guidance",
      title: "RATIONALE GUIDANCE",
      render: (value: string) => (
        <span className="text-sm text-gray-700 leading-snug">
          {value || "-"}
        </span>
      ),
    },
  ];

  const rlColumns = [
    {
      key: "level_code",
      title: "LEVEL CODE",
      render: (value: string) => levelCodeBadge(value, "rl"),
      width: "200px",
    },
    {
      key: "name",
      title: "NAME",
      render: (value: string) => (
        <span className="font-semibold text-gray-900">{value}</span>
      ),
      width: "200px",
    },
    {
      key: "description",
      title: "DESCRIPTION",
      render: (value: string) => (
        <span className="text-gray-700 leading-relaxed">{value || "-"}</span>
      ),
    },
    {
      key: "guidance",
      title: "RATIONALE GUIDANCE",
      render: (value: string) => (
        <span className="text-sm text-gray-700 leading-snug">
          {value || "-"}
        </span>
      ),
    },
  ];

  return (
    <div>
      <div className="mb-4 border-b border-gray-200 pb-4">
        <h1 className="font-semibold text-lg text-gray-900">
          Organization Levels
        </h1>
      </div>

      <section className="mb-8">
        <div className="mb-4">
          <h2 className="text-lg font-medium text-gray-900">
            Account Levels (AL)
          </h2>
          <p className="mt-1 text-sm text-gray-500">
            XFACTOR™ customer alignment maturity — used in account-level
            assessments ({organizationLevels.length} levels)
          </p>
        </div>
        <Table
          columns={alColumns}
          data={organizationLevels}
          loading={levelsLoading}
        />
      </section>

      <section>
        <div className="mb-4">
          <h2 className="text-lg font-medium text-gray-900">
            Relationship Levels (RL)
          </h2>
          <p className="mt-1 text-sm text-gray-500">
            Vendor-customer relationship maturity — used in relationship
            assessments ({relationshipLevels.length} levels)
          </p>
        </div>
        <Table
          columns={rlColumns}
          data={relationshipLevels}
          loading={levelsLoading || relationshipLevelsLoading}
        />
      </section>
    </div>
  );
};

export default VendorLevelContainer;
